import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PaymentSuperFund.css';
import { getAdjustDetail, getSeasonDetail,getUpdateSeason} from '../action/investmentAction.js';
import Util from '../util';
import 'echarts/lib/chart/pie';
import echarts from 'echarts/lib/echarts';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { Toast } from 'antd-mobile/lib';
let width = window.screen.width 
class Transfer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pwdFlag:false,
      transferVal:'',
      transferFlag:false,
      text:''

    };
    this.userMsg={nickName:null,mobileNo:null,name:null}
  }
  componentWillMount(){
    let {dispatch}=this.props
    this.getUserMsg()
    if (this.props.location.state.type===1) {
      document.title = "调整组合"
      dispatch(getAdjustDetail({superFundCode:this.props.location.state.superFundCode},(result)=>this.transferFlag(result)));
    }else{
      document.title = "季度调仓"
      dispatch(getSeasonDetail({superFundCode:this.props.location.state.superFundCode}));
    }

  }
  getUserMsg(){
     this.userMsg=JSON.parse(localStorage.currentUserInfo).userMsg;
     console.log(this.userMsg)
  }
  
  transferFlag(result){
    this.setState({
      transferVal:result.code,
      transferFlag:true,
    })

  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  showKeyboard(){
    const { 
      dispatch,
    }=this.props;
    if (this.state.transferVal=='') {
      this.setState({
        pwdFlag:true
      })
    }else{
      Toast.info(this.state.transferVal, 2);
    }
  }
  onChangePwd(val){
    this.setState({
      text:val
    })
  }
  transfer(type){
    let _this=this;
    const pushResult = (i,result) => {
      if (i==1) {
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'调仓申请结果',
              content:'您的调仓申请已被受理！',
              dataSouse:[['申请编号',result.content.tradeRequestIds],['下单时间',Util.returnDate(result.content.businessTime,true)],['所属交易日',Util.returnDate(result.content.requestWorkday)]],
              souseVal:['返回华夏智投']
            }
          });
      } else if (i==3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'调仓申请结果',
              content:'很抱歉，您的组合调仓申请失败！',
              content2:result,
              dataSouse:[],
              souseVal:['返回华夏智投','联系客服']
            }
          });
      }
    }  
    let date={flag:1,superFundCode:this.props.location.state.superFundCode,password:Util.encrypt(this.state.text)}
    this.props.dispatch(getUpdateSeason(date,pushResult))
  }
  btnCallBack1(){

  }
  
  render(){
    console.log(this.props.location.state)
    let {type,superFundCode,isZJ}=this.props.location.state;
    let {inSeasonDetail}=this.props;
    console.log(inSeasonDetail.previewItemFundsChart,'------')
    let pieImg = "";
    let name=''
    let _img = Util.superFundTextArr(superFundCode, "Transfer")[1];
    pieImg = require("../img/" + _img);
    name = Util.superFundTextArr(superFundCode, "Transfer")[0];
    
    return (
        <div className="container" >
        <NavigatorMain>
          <div className="header">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{type===1?'调整组合':'季度调仓'}</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div style={{WebkitFlex: 1, overflow: "auto"}}>
          <div className='content' style={{paddingBottom:'50px'}}>
            <div className='topBackground'>
            {
              isZJ==1?
               <p>{`${this.userMsg.name?this.userMsg.name:this.userMsg.mobileNo} 您好，欢迎您继续购买${inSeasonDetail.superFund.fundName}。由于您当前持有的组合与标准组合存在偏差，在购买前需要对您当前持有的组合进行调整，调整情况如下：` }</p>
              :<p>{`${this.userMsg.name?this.userMsg.name:this.userMsg.mobileNo}  您好，根据市场环境分析，查理对${inSeasonDetail.superFund.fundName}进行了调整，为保证智投组合的持续稳定收益，并保证最佳的风险收益比，建议您同步进行更新。调整情况如下：` }</p>
            }
            </div>
              <div style={{display: "-webkit-flex",marginTop:'0.12rem',padding:'0 13px',height:'40px',WebkitAlignItems: 'center'}}>
                <p style={{fontSize:'12px',color:"#000",WebkitFlex:1}}>{type==1?'调仓明细':'最新组合配置'}</p>
                <p className='gary12'>{inSeasonDetail.superFund.nextAdjustDate.substring(0,10)+'更新'}</p>
              </div>
              <div style={{background:'#fff',position:'relative'}}>
                

                {
                  inSeasonDetail.previewItemFunds.length==0?null:
                  [
                  <img src={pieImg}  style={{position:'absolute',top:300/2-32,left:width*0.3-32,width:'64px',height:'64px'}} />,
                  <TransferPie inSeasonDetail={inSeasonDetail}/>
                  ]
                }
              </div>
              <div style={{padding:'13px'}}>
                  <p style={{}}>调仓明细</p>
              </div>
              {
                inSeasonDetail.previewItemFunds.map(function (item,i) {
                  return(
                    <div key={'list'+i} style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                      <p className='gary12' style={{WebkitFlex:1,lineHeight:'0.9rem'}}>{item.fundName}</p>
                      <p style={{lineHeight:'0.9rem'}}>{Util.newToFixed(item.holdRate*100)+'%→'+Util.newToFixed(item.targetRegularRate*100)+'%'}</p>
                    </div>
                  )
                })
              }
              <div style={{paddingTop:6}}>
                <div style={{height:'0.9rem',marginLeft:'13px'}}>
                  <p >预估成本</p>
                </div>
              </div>
              <div style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                <p className='gary12' style={{fontSize:'12px',WebkitFlex:1,lineHeight:'0.9rem'}}>预计发生费用</p>
                <p style={{lineHeight:'0.9rem'}}>{ inSeasonDetail.fee !=null ? Util.formatStr(inSeasonDetail.fee) + "元" : "--"}</p>
              </div>
              <div style={{display: "-webkit-flex",background:'#fff',height:'0.9rem',padding:'0 13px'}}>
                <p className='gary12' style={{fontSize:'12px',WebkitFlex:1,lineHeight:'0.9rem'}}>预计完成时间</p>
                <p style={{lineHeight:'0.9rem'}}>{Util.formatStr(inSeasonDetail.needDays)+'日'}</p>
              </div>
              <div style={{display: "-webkit-flex",marginTop:'0.4rem',background:'#fff',height:'0.9rem',padding:'0 13px'}}>
               <p className='gary12' style={{lineHeight:'0.9rem'}}>温馨提示：预计成本仅供参考，请以实际发生费用为准。</p>
              </div>
              
          </div>
          <div style={{position:'fixed',bottom:0,width:'100%',borderTop:'1px solid rgb(224,227,229)'}}>
            <div style={{color:'#5b6370',display: "-webkit-flex",WebkitAlignItems:'center',overflow:'hidden',border:'1px solid rgb(224,227,279)'}}>
              <p onClick={hashHistory.goBack} style={{background:'rgba(242,245,247,1)',textAlign:'center',height:'40px',WebkitFlex:1,display: "-webkit-flex",
                WebkitFlexDirection: 'column',
                WebkitJustifyContent: 'center',
                WebkitAlignItems: 'center'}}>
              <img src={require('../img/icon11.png')} style={{width:18,height:18}}/>暂不调仓</p>
              <p onClick={()=>this.showKeyboard(type)} style={{color:'#fff',backgroundColor:'#fa063a',textAlign:'center',height:'40px',lineHeight:'40px',WebkitFlex:3}}>确认调仓</p>
            </div>
          </div>
          {
            this.state.pwdFlag?
            <div style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
              <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                <div style={{position:'relative',height:'0.9rem',lineHeight:'0.9rem',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)'}}>
                  交易密码
                  <img src={require('../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                  <span  style={{position:'absolute',top:0,right:0,width:'0.9rem'}} onClick={()=>{this.transfer(type)}}> 确认</span>
                </div>
                <div style={{height:'0.9rem',padding:'13px'}}>
                  <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)}  autofocus="autofocus" style={{height:'0.9rem',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                </div>
              </div>
            </div>
            :null
          }
          </div>
        </div>
    );
  }
}
function compare(prop){
    return function (obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
      }
      if (val1 > val2) {
          return -1;
      } else if (val1 < val2) {
          return 1;
      } else {
          return 0;
      }            
    }
}
class TransferPie extends Component {
  componentDidMount() {
    let {inSeasonDetail}=this.props;
    let dataSouse=[];
    let dataSouseName=[];
    inSeasonDetail.previewItemFundsChart.sort(compare("srcRegularRate"))
    for (var i = 0; i < inSeasonDetail.previewItemFundsChart.length; i++) {
      let item=inSeasonDetail.previewItemFundsChart[i]

      let name=item.styleTypeName+Util.newToFixed(item.srcRegularRate*100)+'%'
      dataSouse.push(
        {value:Util.newToFixed(item.srcRegularRate*100), name:name}
      )
      dataSouseName.push(name)
    }
    let corArr = ['#e85040','#ff7242','#28b7f6','#7290fd','#9bcd65','#ab47bc'];
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById('TransferPie'));
    }else{
      var myChart = echarts.init(document.getElementById('TransferPie'), null, {renderer: 'svg'});
    }
    // 绘制图表
    myChart.setOption(SuperPieOption(dataSouse,dataSouseName));
  }
  render(){
    
    return(
      <div id="TransferPie" style={{ width:"100%", height:300}}>
         
      </div>
    )
  }
}

/*饼图Option*/
function SuperPieOption(data,dataName){
  let colorArr = [];
  if(dataName){
  dataName.map((item,key)=>{
      if(item.indexOf("跨境权益") != -1){
        colorArr.push("#4729c5")
      }else if(item.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(item.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(item.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(item.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(item.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
    })
  }
  let hg = 60;
  if( dataName.length <= 2){
    hg = 20;
  }else if(dataName.length <= 4){
    hg=60;
  }else if(dataName.length <= 6){
    hg=80;
  }else if(dataName.length <= 8){
    hg=100;
  }

  let SuperPieOption = {
      animation: window.isLess47,
      calculable : true,
      legend: {
          y : 'center',
          x: 'left',
          left:width/2 + 40,
          orient:'vertical',
          data:dataName,
          //height:hg,
          itemWidth:14,
          selectedMode:false,
          textStyle:{color:"auto"}
      },
      series : [
          {   
              minAngle:20,
              type:'pie',
              hoverAnimation:false,
              radius : [44, 75],
              center : ['30%', '50%'],
              roseType : 'radius',
              data:data,
            label:{
              normal:{
                show:false
              }
            },
            labelLine:{
              normal:{
                show:false
              }
            },

          }

      ],
      color:colorArr
    };
  return SuperPieOption;
}
function mapStateToProps(state, ownProps) {
  return {
    inSeasonDetail:state.inSeasonDetail,
  }
}
export default connect(mapStateToProps)(Transfer);



// WEBPACK FOOTER //
// ./src/components/Transfer.js